import { IChallengeDetail, IChallengeLeaderboardItem } from '../interfaces/challenges';

const RECOMMENDATION_IN_MINUTES = 'We recommend a goal between 100 and 300 minutes of activity\nto make it achievable.';
const MAX_VALUE_OF_MINUTES = '300';
const MIN_VALUE_OF_MINUTES = '100';
const GOAL_MEASURED_IN_MINUTES = 'minutes of activity';
const LABEL_OF_MINUTES = 'Enter a goal for minutes of activity.';
const DESCRIPTION_OF_MINUTES = 'Minutes of activity recorded';

export const MOCK_GET_CHALLENGES_INFO = [
  {
    type: 'training',
    icon: 'https://static.gobetterfly.com/b2b/challenges/types/training.svg',
    title: 'Training',
    description: 'Yoga, HIIT, Running, Weight Training',
    createChallengeLabel: LABEL_OF_MINUTES,
    goalMeasured: GOAL_MEASURED_IN_MINUTES,
    recommendation: RECOMMENDATION_IN_MINUTES,
    maxValueGoal: MAX_VALUE_OF_MINUTES,
    minValueGoal: MIN_VALUE_OF_MINUTES
  },
  {
    type: 'swimming',
    icon: 'https://static.gobetterfly.com/b2b/challenges/types/swimming.svg',
    title: 'Swimming',
    description: DESCRIPTION_OF_MINUTES,
    createChallengeLabel: LABEL_OF_MINUTES,
    goalMeasured: GOAL_MEASURED_IN_MINUTES,
    recommendation: RECOMMENDATION_IN_MINUTES,
    maxValueGoal: MAX_VALUE_OF_MINUTES,
    minValueGoal: MIN_VALUE_OF_MINUTES
  },
  {
    type: 'meditation',
    icon: 'https://static.gobetterfly.com/b2b/challenges/types/meditation.svg',
    title: 'Meditation',
    description: DESCRIPTION_OF_MINUTES,
    createChallengeLabel: LABEL_OF_MINUTES,
    goalMeasured: GOAL_MEASURED_IN_MINUTES,
    recommendation: RECOMMENDATION_IN_MINUTES,
    maxValueGoal: MAX_VALUE_OF_MINUTES,
    minValueGoal: MIN_VALUE_OF_MINUTES
  },
  {
    type: 'donations',
    icon: 'https://static.gobetterfly.com/b2b/challenges/types/donations.svg',
    title: 'Donations',
    description: 'Number of donations made',
    createChallengeLabel: 'Enter a goal for Donations.',
    goalMeasured: 'Donations',
    recommendation: 'We recommend a goal between 5 and 10 Donations\nto make it achievable.',
    maxValueGoal: '10',
    minValueGoal: '5'
  },
  {
    type: 'bike',
    icon: 'https://static.gobetterfly.com/b2b/challenges/types/bike.svg',
    title: 'Bicycle',
    description: 'Number of kilometers traveled',
    createChallengeLabel: LABEL_OF_MINUTES,
    goalMeasured: GOAL_MEASURED_IN_MINUTES,
    recommendation: RECOMMENDATION_IN_MINUTES,
    maxValueGoal: MAX_VALUE_OF_MINUTES,
    minValueGoal: MIN_VALUE_OF_MINUTES
  },
  {
    type: 'steps',
    icon: 'https://static.gobetterfly.com/b2b/challenges/types/steps.svg',
    title: 'Steps',
    description: 'Number of steps recorded',
    createChallengeLabel: 'Enter a goal for Steps.',
    goalMeasured: 'Steps',
    recommendation: 'We recommend a goal between 100.000 and 300.000 Steps\nto make it achievable.',
    maxValueGoal: '300.000',
    minValueGoal: '100.000'
  }
];

export const MOCK_GET_COMPANY_CHALLENGES: IChallengeDetail[] = [
  {
    id: 'u0DoWvKqEyymx0dLDWsg',
    instanceId: 'instance1',
    leaderboardId: 'leaderboard1',
    name: 'Tipo challenge en',
    description: 'Tipo challenge en',
    participants: 0,
    status: 'active',
    startAt: '2024-08-15T19:00:00.000Z',
    endAt: '2024-08-17T00:00:00.000Z',
    unit: 'donation',
    leaderboard: [],
    type: 'food-donation',
    typeName: 'Donations',
    author: '',
    iconUrl: 'https://static.gobetterfly.com/b2b/challenges/types/donations.svg',
    pictogram: '',
    participantsPercentageOverAverage: 0
  },
  {
    id: '1gg4Xk592uPZ8l5bnoAs',
    instanceId: 'instance2',
    leaderboardId: 'leaderboard2',
    name: 'Challenge creación. ',
    description: 'Challenge creación. Chile Test Chile Edit descripción',
    participants: 1,
    status: 'active',
    startAt: '2024-10-01T00:00:00.000Z',
    endAt: '2024-10-03T02:59:59.000Z',
    unit: 'minute',
    typeName: 'Training',
    leaderboard: [
      {
        id: 'lOu7UnvmSl5uQ7f4pWEK',
        score: 0,
        position: 0,
        name: 'Johnny Test',
        icon: null
      }
    ],
    type: 'training',
    author: '',
    iconUrl: 'https://static.gobetterfly.com/b2b/challenges/types/training.svg',
    pictogram: 'sportsDumbbell1',
    participantsPercentageOverAverage: 150
  },
  {
    id: 'd4svrQ6g70AQUXGs5IqR',
    instanceId: 'instance3',
    leaderboardId: 'leaderboard3',
    name: 'ewe',
    description: 'ewe',
    participants: 1,
    status: 'active',
    startAt: '2024-09-29T22:00:00.000Z',
    endAt: '2024-10-30T23:59:59.000Z',
    unit: 'step',
    typeName: 'Steps',
    leaderboard: [
      {
        id: 'lOu7UnvmSl5uQ7f4pWEK',
        score: 0,
        position: 0,
        name: 'Johnny Test',
        icon: 'https://dev.media.players-mgmt.platform.betterfly.com/players-photos/7d1580a9e3b1f202d7ffd22e35ec71a8c298ce9264a514d0b895d3b8bbaf9e31/display-photo-1703076846070-60x60.jpg'
      }
    ],
    type: 'steps',
    author: '',
    iconUrl: 'https://static.gobetterfly.com/b2b/challenges/types/steps.svg',
    pictogram: 'activitySteps',
    participantsPercentageOverAverage: 150
  }
];

export const MOCK_GET_LEADERBOARD: IChallengeLeaderboardItem[] = [
  {
    id: 'lOu7UnvmSl5uQ7f4pWEK',
    score: 0,
    position: 0,
    name: 'Johnny Test',
    icon: 'https://dev.media.players-mgmt.platform.betterfly.com/players-photos/7d1580a9e3b1f202d7ffd22e35ec71a8c298ce9264a514d0b895d3b8bbaf9e31/display-photo-1703076846070-60x60.jpg'
  }
];
